import { List, Typography } from "@mui/material";

import LoadingIndicator from "../../Common/LoadingIndicator/LoadingIndicator";

import ContractsListItem from "./ContractsListItem";
import ContractsTableHeader from "./ContractsTableHeader";

export default function ContractsTable({
  data,
  isLoading,
  onDelete,
  onEdit,
  canEdit = false,
  canDelete = false,
}) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data || data.length === 0) {
    return <Typography className="text-center">No contracts</Typography>;
  }

  return (
    <div className="absolute bottom-0 top-0 flex w-full flex-col overflow-y-auto px-2 [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <ContractsTableHeader showActions={canEdit || canDelete} />
      <List className="flex h-full flex-col gap-4" disablePadding>
        {Array.isArray(data) &&
          data.map((contract) => (
            <ContractsListItem
              key={contract?.id}
              data={contract}
              onDelete={onDelete}
              onEdit={onEdit}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          ))}
      </List>
    </div>
  );
}
